export function splitRsvpFullName(fullName: string): {
  firstName: string;
  lastName: string;
} {
  const [firstName = "", ...lastNameParts] = fullName
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  return {
    firstName,
    lastName: lastNameParts.join(" "),
  };
}
